import 'jquery';

/**
 * @see https://stripe.com/docs/testing
 * @see https://stripe.com/docs/stripe-js/elements/payment-request-button
 *
 */

(function ($) {
  let configEl = $('script#stripeButtonConfig');

  if (!configEl.length) {
    return;
  }

  let form = $('form[data-submit="stripeButton"]'),
    // GPay and ApplePay Buttons in checkout top navigation
    buttons = $('li[data-payment-method]'),
    config = JSON.parse(configEl.get(0).textContent),
    tabs = $('ul.nav.payment-tabs'),
    owner = config.config || {},
    // connected account
    accountId = ((typeof owner.accountId == 'string' && owner.accountId) ? owner.accountId : null),
    stripeConfig = {
      locale: config.language,
      apiVersion: '2020-03-02',
    },
    button = (typeof configEl.data('button') === 'object' ? configEl.data('button') : null),
    stripeLinkButton = $('#stripeLinkButton'),
    body = $('body');

  // https://stripe.com/docs/js/initializing#init_stripe_js-options
  // this should be a connected account
  if (accountId) {
    stripeConfig['stripeAccount'] = accountId;
  }

  /**
   * Initialize stripe button functionality in plenigo JS SDK
   */
  if (button !== null) {
    // if we did the check before, use result from session
    buttons.each(function () {
      if (typeof button[$(this).data('paymentMethod')] === 'boolean' && button[$(this).data('paymentMethod')]) {
        $(this).removeClass('hidden');
      } else {
        $(this).remove();
      }
    });

    if (Object.values(button).filter((value) => true === value).length > 1) {
      stripeLinkButton.remove();
    }

  } else {
    /**
     * we have to initialize in JS SDK
     * Here we trigger the init event, in iframe.js we will dispatch it to
     * iframe.checkForStripeButtons in plenigo SDK
     */
    body.trigger('plenigo.initStripeButtons', {
      lib: 'https://js.stripe.com/v3/',
      stripeConfig: stripeConfig,
      paymentRequestConfig: config.paymentRequest,
      publicKey: owner.publicKey,
      clientSecret: owner.clientSecret,
    });
  }

  if (buttons.filter(':visible').length) {
    tabs.children('[data-prio="5"]').addClass('hidden');
  }

  /**
   * Callback from SDK. Triggered from outside of plenigo checkout iframe
   */
  body.on('plenigo.stripeButtons', function (event, result) {
    if (result) {
      buttons.each(function () {
        if (typeof result[$(this).data('paymentMethod')] === 'boolean' && result[$(this).data('paymentMethod')]) {
          $(this).removeClass('hidden');
          tabs.find('li[data-prio="5"]').addClass('hidden');
          // store result in session

          $(document).trigger('plenigo.resize');

          $.ajax({
            data: JSON.stringify(result),
            dataType: 'json',
            method: 'POST',
            url: configEl.data('url'),
          }).done(function (response) {
            console.log(response);
          });
        }
      });
      // enable buttons
      // filter, if there are mor than one button
      // hide link button
      if (Object.values(result).filter((value) => true === value).length > 1) {
        stripeLinkButton.remove();
      }
    }
  })
    // payment success
    .on('plenigo.stripeButtonsSuccess', function (event, result) {
      if (result) {
        form.find(':input[data-paymentintent]:first').val(result.paymentIntent.payment_method);
        form.find(':submit').prop('disabled', false);
        console.log('stripeButtonsSuccess', result);
        form.submit();
      }
    })
    .on('plenigo.stripeButtonsCancel', function () {
      location.reload();
    })
    .on('click', 'button[data-widget="stripePaymentButton"]', function () {
      let button = $(this);
      body.trigger('plenigo.showStripeButtonPayment');
      button.addClass('loading');
      window.setTimeout(function (){
        button.addClass('hidden');
        form.find(':submit').removeClass('hidden');
      }, 1000);
    })
    // payment error. Handle error
    .on('plenigo.stripeButtonsError', function (event, result) {
      if (result) {
        console.log('stripeButtonsError', result);
      }
    });

}(jQuery));
